export const assignmentField = {
  key: '@assignment',
  hidden: false,
  disabled: false,
  required: false,
  label: 'Assigned To',
  type: 'AssignmentField',
  data_name: 'assigned_to_id',
};

export const projectField = {
  key: '@project',
  hidden: false,
  disabled: false,
  required: false,
  label: 'Project',
  description: 'Select a project',
  type: 'ProjectField',
};

export const issueLinkField = {
  key: 'issue_link',
  data_name: 'issues',
  hidden: false,
  label: 'Linked Issue',
  description: 'Linked Issue',
  type: 'RecordLinkField',
};

export const locationField = {
  key: '@location',
  visible: true,
  disabled: false,
  required: false,
  label: 'Location',
  type: 'LocationField',
};

export const combinedCreatedField = {
  key: '@combined_created',
  visible: true,
  disabled: false,
  required: false,
  label: 'Created',
  type: 'CombinedCreatedField',
};

export const repeatField = {
  key: '@repeat',
  dataName: 'record_series',
  hidden: false,
  disabled: false,
  required: false,
  label: 'Repeat',
  type: 'RepeatField',
};
